import { Pill, type PillProps } from "../ui/pill"

export { Pill }
export type { PillProps }
